




































import { Component, Vue, Emit, Prop, Watch } from "vue-property-decorator";
import { getStatusBarHeight } from "@/utils/js_bridge_info";
import SelectUser from "@/components/SelectUser/SelectUser.vue";
import { Getter } from "vuex-class";
import { GETTER_CURRENT_INS_USER_INFO } from "@/store/constants/ins_user_info_types";
@Component({
  components: { SelectUser }
})
export default class NavTab extends Vue {
  @Getter(GETTER_CURRENT_INS_USER_INFO)
  private currentUserInfo: any;
  @Prop({ default: 0 })
  private value!: number;
  @Prop({ default: true })
  private isNeedPadTop?: boolean;
  @Prop()
  private tabsNav?: any;
  @Prop({ default: 36 })
  private labelWidth!: number;
  @Prop({
    default: false
  })
  private router?: boolean;
  @Prop({
    default: true
  })
  private userAccountSelect?: boolean;
  @Prop({
    default: false
  })
  private leftIcon?: any;
  @Prop({
    default: ""
  })
  private border?: boolean;
  @Prop({
    default: ""
  })
  private layout?: string;
  @Prop({
    default: "tab-two"
  })
  private tabClass?: string; // tabInner的宽度占整个tab的宽度
  private androidStatusBarHeight = "";

  private offsetX: number = 0; // 底部状态条的位置

  private activeIndex: number = 0; // 当前激活状态的状态index

  private tabItemWidthList: any = [];

  @Watch("value", { immediate: true })
  private valuechange(val: string, oldVal: string) {
    this.activeIndex = this.value;
    this.setOffsetX();
  }

  get currentUserIcon() {
    return (
      this.currentUserInfo &&
      this.currentUserInfo.ins_user_info &&
      this.currentUserInfo.ins_user_info.profile_pic_url
    );
  }

  get statusBarHeight() {
    return this.isNeedPadTop ? `padding-top:${getStatusBarHeight()}px` : "";
  }

  private getColorStyle(index: number, item: any) {
    const color = this.value === index ? item.labelColor : "#a3a3a3";
    return `color:${color}`;
  }

  private mounted() {
    this.initTab();
  }

  private initTab() {
    this.$nextTick(() => {
      this.getTabItemWidthList();
      this.setOffsetX();
    });
  }

  private getTabItemWidthList() {
    for (let i = 0; i < this.tabsNav.length; i++) {
      const ref = "tab-nav-item" + i;
      const itemDom = this.$refs[ref] as any;
      const itemWidth =
        itemDom && (itemDom.clientWidth || itemDom[0].clientWidth);
      this.tabItemWidthList.push(itemWidth);
    }
  }

  private clickSelectUser() {
    this.$emit("clickSelectUser");
  }

  /**
   * @emit 修饰了函数的一个传入的第一个参数
   */
  private clickTab(index: number, item: any) {
    if (this.activeIndex !== index) {
      this.activeIndex = index;
      this.setOffsetX();
      this.$emit("input", index);
    }
  }

  private get currentLabelColor() {
    return this.tabsNav[this.activeIndex].labelColor;
  }

  get lineStyle() {
    return {
      transform: "translate3d(" + this.offsetX + "px,0,0)",
      backgroundColor: this.currentLabelColor
    };
  }

  private clickUserAccount() {
    this.$emit("clickUserAccount");
  }

  private leftIconClick() {
    this.$emit("leftIconClick");
  }

  private setOffsetX() {
    const sliceList = this.tabItemWidthList.slice(0, this.activeIndex);
    let leftWidth = 0;
    if (sliceList.length > 0) {
      for (const j of sliceList) {
        leftWidth += j;
      }
    }
    this.offsetX =
      leftWidth +
      (this.tabItemWidthList[this.activeIndex] - this.labelWidth) / 2;
  }
}
